import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

const useGaTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!window.location.href.includes('localhost')) {
      //console.log('GA_CODE: ' + process.env.REACT_APP_GOOGLE_ANALYTCS_CODE);
      const gacode = process.env.REACT_APP_GOOGLE_ANALYTCS_CODE!;
      ReactGA.initialize(gacode, { debug: false });
    }
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (initialized) {
      //console.log('TRACKING: ' + location.pathname + location.search);
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [initialized, location]);
};

export default useGaTracker;
